import { Divider, Flex } from "@chakra-ui/react";
import CTable from "../CTable/Ctable";
import styles from "./OrderBook.module.scss";
import { WsResponseOrderBook } from "src/api/ws";
import { useMemo } from "react";

type OrderBookItem = {
  price: number;
  amount: number;
  sum: string;
  bidTotal?: string;
  bidUTotal?: string;
  askTotal?: string;
  askUTotal?: string;
};

const cols = [
  { key: "price", title: "价格" },
  { key: "amount", title: "数量" },
  { key: "sum", title: "金额" },
];

const bidCols = [
  { key: "bidTotal", title: "合计Token" },
  { key: "bidUTotal", title: "合计USDT" },
];

const askCols = [
  { key: "askTotal", title: "合计Token" },
  { key: "askUTotal", title: "合计USDT" },
];

const OrderBook = (props: { info: WsResponseOrderBook }) => {
  const bids: OrderBookItem[] = useMemo(() => {
    let bidSum1 = 0,
      bidSum2 = 0;
    return (
      props.info?.bids?.map(([price, amount, sum]) => {
        bidSum1 += amount;
        bidSum2 += sum;
        return {
          price,
          amount,
          sum: sum.toFixed(2),
          bidTotal: bidSum1.toFixed(2),
          bidUTotal: bidSum2.toFixed(2),
        };
      }) || []
    );
  }, [props.info?.bids]);

  const asks: OrderBookItem[] = useMemo(() => {
    let askSum1 = 0,
      askSum2 = 0;
    return (
      props.info?.asks?.map(([price, amount, sum]) => {
        askSum1 += amount;
        askSum2 += sum;
        return {
          price,
          amount,
          sum: sum.toFixed(2),
          askTotal: askSum1.toFixed(2),
          askUTotal: askSum2.toFixed(2),
        };
      }) || []
    );
  }, [props.info?.asks]);

  return (
    <Flex>
      <Flex justifyContent="space-around" my={4} width="100%">
        <CTable items={bids} cols={[...cols, ...bidCols]} showHeader classname={styles.ask} />
        <Divider orientation="vertical" height="100%" mx={4} />
        <CTable items={asks} cols={[...cols, ...askCols]} showHeader classname={styles.bid} />
      </Flex>
    </Flex>
  );
};

export default OrderBook;
